import React, { useState, useEffect } from "react";
import CreatePollCard from "./createPollCard/CreatePollCard";
import PollCard from "./pollCard/PollCard";
import './polls.css';
import { useNavigate } from 'react-router-dom';
import { message } from "antd";


interface PollsProps {
    changeActiveTab: (tabName: string) => (event: React.MouseEvent) => void
    requestUrl: string;
    refreshRequestBody: any
}

const Polls: React.FC<PollsProps> = ({ changeActiveTab, requestUrl, refreshRequestBody }) => {
    const [renderedPolls, setRenderedPolls] = useState<JSX.Element | undefined>(undefined)

    const navigate = useNavigate()

    useEffect(() => {
        const renderPolls =  async (pollPresponse: any) => {
            const polls =  await pollPresponse;
            if(polls) {
                setRenderedPolls(
                    polls.results.map((poll: any) => {
                        return (
                            <PollCard 
                                key={poll.id} 
                                poll={poll}
                            /> 
                        )
                    })
                )
            }  
        }

        if(!renderedPolls) {
            const requestOptions = {
                method: 'GET',
                headers : {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${window.localStorage.getItem('access')}`
                }
            }

            fetch(`${requestUrl}/polling/polls/`, requestOptions)
                .then(response => {
                    switch (response.status) {
                        case 200:
                            renderPolls(response.json())
                            break
                        case 401:
                            const refreshToken = fetch(`${requestUrl}/auth/token/refresh/`, refreshRequestBody)
                                .then(response => {
                                    if(response.status === 200){
                                        return response.json()
                                    } else {
                                        message.warning('Session expired')
                                        navigate('/login')
                                    }
                                })
                            
                            const bringPolls = async () => {
                                const newAccessToken = await refreshToken
                                if(newAccessToken) {
                                    window.localStorage.setItem('access', newAccessToken.access)

                                    const newRequestOptions =  {
                                        method: 'GET',
                                        headers : {
                                            'Content-Type': 'application/json',
                                            'Authorization': `Bearer ${newAccessToken.access}`
                                        }
                                    }
        
                                    fetch(`${requestUrl}/polling/polls/`, newRequestOptions)
                                    .then(response => response.json())
                                    .then(result => renderPolls(result))  
                                }
                            }
                            bringPolls()
                    }
                })
        }   
    }, [renderedPolls, requestUrl, navigate, changeActiveTab, refreshRequestBody])

    return(
        <div className='polls'>
            <CreatePollCard refreshRequestBody={refreshRequestBody} requestUrl={requestUrl}/>
            {renderedPolls}
        </div>  
    )
};

export default Polls;